export class Agencies {
    public static All = {
        "http://54.186.131.135": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://demo.insuredmine.com/agent",
            "homePageUrl": "https://www.insuredmine.com/user",
            "contactUrl": "https://www.insuredmine.com/contact",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "http://localhost:8000": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://demo.insuredmine.com/agent",
            "homePageUrl": "https://www.insuredmine.com/user",
            "contactUrl": "https://www.insuredmine.com/contact",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "http://localhost:4200": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://demo.insuredmine.com/agent",
            "homePageUrl": "https://www.insuredmine.com/user",
            "contactUrl": "https://www.insuredmine.com/contact",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "https://demo.insuredmine.com": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://demo.insuredmine.com/agent",
            "homePageUrl": "https://www.insuredmine.com/user",
            "contactUrl": "https://www.insuredmine.com/contact",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            },
            "signup": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://www.insuredmine.com/user/assets/images/IM-Logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },

        //search lkeey se hoa
        "https://www.demo.insuredmine.com": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://www.demo.insuredmine.com/agent",
            "homePageUrl": "https://www.demo.insuredmine.com",
            "contactUrl": "https://coveragedirect.com/contact/",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            },
            "signup": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://www.insuredmine.com/user/assets/images/IM-Logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "https://motivity.insuredmine.com": {
            "name": "InsuredMine",
            "agentPortalUrl": "https://motivity.insuredmine.com/agent",
            "homePageUrl": "https://motivity.insuredmine.com",
            "contactUrl": "https://coveragedirect.com/contact/",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            },
            "signup": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://www.insuredmine.com/user/assets/images/IM-Logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "https://www.insuredmine.com": {
            "name": "InsuredMine",
            "contactUrl": "https://www.insuredmine.com/contact",
            "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
            "login": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            },
            "signup": {
                "logo": "https://image.ibb.co/f0QSRy/insured_logo.png",
                "redirectUrl": "https://www.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://www.insuredmine.com/user/assets/images/IM-Logo.png",
                "redirectUrl": "https://www.insuredmine.com"
            }
        },
        "https://coveragedirect.insuredmine.com": {
            "name": "Coverage Direct",
            "agentPortalUrl": "https://coveragedirect.insuredmine.com/agent",
            "homePageUrl": "https://coveragedirect.insuredmine.com/",
            "contactUrl": "https://coveragedirect.com/contact/",
            "logo": "https://coveragedirect.com/wp-content/uploads/sites/61/2016/05/logo-tall.png",
            "login": {
                "logo": "https://coveragedirect.com/wp-content/uploads/sites/61/2016/05/logo-tall.png",
                "redirectUrl": "https://coveragedirect.insuredmine.com"
            },
            "signup": {
                "logo": "https://coveragedirect.com/wp-content/uploads/sites/61/2016/05/logo-tall.png",
                "redirectUrl": "https://coveragedirect.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://coveragedirect.com/wp-content/uploads/sites/61/2016/05/logo-tall.png",
                "redirectUrl": "https://coveragedirect.insuredmine.com"
            }
        },
        "https://trustedinsurancepartners.insuredmine.com": {
            "name": "Trusted Insurance Partners",
            "agentPortalUrl": "https://trustedinsurancepartners.insuredmine.com/agent",
            "homePageUrl": "https://trustedinsurancepartners.insuredmine.com/",
            "contactUrl": "http://www.trustedinsurancepartners.com/",
            "logo": "https://insuredmine.com/images/trusted-insurance/rsz_15rsz_logo_2_portal.png",
            "login": {
                "logo": "https://insuredmine.com/images/trusted-insurance/rsz_15rsz_logo_2_portal.png",
                "redirectUrl": "https://trustedinsurancepartners.insuredmine.com"
            },
            "signup": {
                "logo": "https://insuredmine.com/images/trusted-insurance/rsz_15rsz_logo_2_portal.png",
                "redirectUrl": "https://trustedinsurancepartners.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://insuredmine.com/images/trusted-insurance/rsz_15rsz_logo_2_portal.png",
                "redirectUrl": "https://trustedinsurancepartners.insuredmine.com"
            }
        },
        "https://chamblissinsurance.insuredmine.com": {
            "name": "Chambliss Premier Insurance",
            "agentPortalUrl": "https://chamblissinsurance.insuredmine.com/agent",
            "homePageUrl": "https://chamblissinsurance.insuredmine.com/",
            "contactUrl": "http://www.chamblissinsurance.com/",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/carneal_logo-2_vhfjqz.png",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/carneal_logo-2_vhfjqz.png",
                "redirectUrl": "https://chamblissinsurance.insuredmine.com"
            },
            "signup": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/carneal_logo-2_vhfjqz.png",
                "redirectUrl": "https://chamblissinsurance.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/carneal_logo-2_vhfjqz.png",
                "redirectUrl": "https://chamblissinsurance.insuredmine.com"
            }
        },
        "https://phpbroker.insuredmine.com": {
            "name": "PHP Brokers",
            "agentPortalUrl": "https://phpbroker.insuredmine.com/agent",
            "homePageUrl": "https://phpbroker.insuredmine.com/",
            "contactUrl": "http://www.phpbroker.com/",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/php_logo-2_lhblfx.png",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/php_logo-2_lhblfx.png",
                "redirectUrl": "https://phpbroker.insuredmine.com"
            },
            "signup": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/php_logo-2_lhblfx.png",
                "redirectUrl": "https://phpbroker.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1539614329/php_logo-2_lhblfx.png",
                "redirectUrl": "https://phpbroker.insuredmine.com"
            }
        },
        "https://pinnacleinsurance.insuredmine.com": {
            "name": "PHP Brokers",
            "agentPortalUrl": "https://pinnacleinsurance.insuredmine.com/agent",
            "homePageUrl": "https://pinnacleinsurance.insuredmine.com/",
            "contactUrl": "http://www.pinnacleinsurance.biz/",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1540238231/pinnacle_2_yf6rod.jpg",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1540238231/pinnacle_2_yf6rod.jpg",
                "redirectUrl": "https://pinnacleinsurance.insuredmine.com"
            },
            "signup": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1540238231/pinnacle_2_yf6rod.jpg",
                "redirectUrl": "https://pinnacleinsurance.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1540238231/pinnacle_2_yf6rod.jpg",
                "redirectUrl": "https://pinnacleinsurance.insuredmine.com"
            }
        },
        "https://shamrockinsuranceagency.insuredmine.com": {
            "name": "PHP Brokers",
            "agentPortalUrl": "https://shamrockinsuranceagency.insuredmine.com/agent",
            "homePageUrl": "https://shamrockinsuranceagency.insuredmine.com/",
            "contactUrl": "http://www.flowersinsuranceagency.com/contact-us/",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
                "redirectUrl": "https://shamrockinsuranceagency.insuredmine.com"
            },
            "signup": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
                "redirectUrl": "https://shamrockinsuranceagency.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1541279714/sholak_neajuz.png",
                "redirectUrl": "https://shamrockinsuranceagency.insuredmine.com"
            }
        },
        "https://dmwagency.insuredmine.com": {
            "name": "Dan M Weier Agency",
            "agentPortalUrl": "https://dmwagency.insuredmine.com/agent",
            "homePageUrl": "https://dmwagency.insuredmine.com/",
            "contactUrl": "https://insuredmine.com/contact",
            "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1544614458/On-Boarding%20Customers/agency.png",
            "login": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1544614458/On-Boarding%20Customers/agency.png",
                "redirectUrl": "https://dmwagency.insuredmine.com"
            },
            "signup": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1544614458/On-Boarding%20Customers/agency.png",
                "redirectUrl": "https://dmwagency.insuredmine.com",
                "terms": "https://www.insuredmine.com/terms"
            },
            "home": {
                "logo": "https://res.cloudinary.com/www-insuredmine-com/image/upload/v1544614458/On-Boarding%20Customers/agency.png",
                "redirectUrl": "https://dmwagency.insuredmine.com"
            }
        },
    }
}